import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthRequestBnbaccess } from './auth-request-bnbaccess.model';
import { AuthRequestBnbaccessService } from './auth-request-bnbaccess.service';
@Injectable()
export class AuthRequestBnbaccessPopupService {
    private isOpen = false;
    constructor (
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private authRequestService: AuthRequestBnbaccessService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.authRequestService.find(id).subscribe(authRequest => {
                authRequest.tokenExpiration = this.datePipe.transform(authRequest.tokenExpiration, 'yyyy-MM-ddThh:mm');
                this.authRequestModalRef(component, authRequest);
            });
        } else {
            return this.authRequestModalRef(component, new AuthRequestBnbaccess());
        }
    }

    authRequestModalRef(component: Component, authRequest: AuthRequestBnbaccess): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.authRequest = authRequest;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess-popup.service.ts